import { Modal } from "@seneca/senekit";

import { SignUpCard } from "../common-routes/components/Layout";
import SignInCardContainer from "../sign-in-form/components/SignInCard/components/containers/SignInCardContainer";

type Props = {
  linkToSignUp: string;
  linkToPasswordReset: string;
  redirectAuthenticatedUserTo?: string;
  frontdoor?: boolean;
  modalProps: {
    partOfJourney: boolean;
    fullscreenOnMobile: boolean;
    onCloseClick?: () => void;
  };
};

export default function SignIn({ modalProps, ...props }: Props) {
  if (props.frontdoor) {
    return (
      <SignUpCard>
        <SignInCardContainer {...props} />
      </SignUpCard>
    );
  }

  return (
    <Modal maxWidth="medium" {...modalProps}>
      <SignInCardContainer {...props} />
    </Modal>
  );
}
